module.exports = __webpack_public_path__ + "static/img/process_bank_img.35954e7.png";